import { createContext, useContext, useEffect, useState } from 'react';
import type { ReactNode } from 'react';

const BANNER_HEIGHT = 44;
const STORAGE_KEY = 'renova-promo-dismissed-spring25';

interface PromoBannerContextType {
  bannerVisible: boolean;
  dismiss: () => void;
  bannerHeight: number;
}

const PromoBannerContext = createContext<PromoBannerContextType>({
  bannerVisible: false,
  dismiss: () => {},
  bannerHeight: 0,
});

export const usePromoBanner = () => useContext(PromoBannerContext);

export const PromoBannerProvider = ({ children }: { children: ReactNode }) => {
  const [dismissed, setDismissed] = useState<boolean>(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  });

  const bannerVisible = !dismissed;
  const bannerHeight = bannerVisible ? BANNER_HEIGHT : 0;

  const dismiss = () => {
    setDismissed(true);
    try {
      localStorage.setItem(STORAGE_KEY, '1');
    } catch {
      // ignore storage errors
    }
  };

  useEffect(() => {
    document.documentElement.style.setProperty(
      '--promo-height',
      bannerVisible ? `${BANNER_HEIGHT}px` : '0px',
    );
  }, [bannerVisible]);

  return (
    <PromoBannerContext.Provider value={{ bannerVisible, dismiss, bannerHeight }}>
      {children}
    </PromoBannerContext.Provider>
  );
};
